<template>
    <v-container grid-list-md class="fb-post-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_fb_post_process">
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Nhập link FB cá nhân:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="linkOrId"
                                    placeholder="Nhập link FB cá nhân:"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row v-if="videoId">
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>
                    
                    <v-layout v-if="typeSeedings.length > 0" align-center row>
                        <v-flex md4>
                            <label class="text-color">Loại Seeding cần tăng:</label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <label v-for="item in typeSeedings"
                                   :key="item.value"
                                   class="answer-radio-container">
                                <input :value="item.value"
                                       :key="item.value"
                                       v-model="typeSeeding"
                                       type="radio"
                                       @change="initDefault">
                                {{ item.name }} <br>
                            </label>
                        </v-flex>
                    </v-layout>

                    <!--                <v-layout align-center row>-->
                    <!--                    <v-flex md4>-->
                    <!--                        <label class="text-color">Chế độ bảo hành:</label>-->
                    <!--                    </v-flex>-->
                    <!--                    <v-flex md8 pt-6>-->
                    <!--                        <v-select-->
                    <!--                                solo-->
                    <!--                                :items="warranties"-->
                    <!--                                v-model="warranty"-->
                    <!--                                item-text="name"-->
                    <!--                                item-value="value"-->
                    <!--                        ></v-select>-->
                    <!--                    </v-flex>-->
                    <!--                </v-layout>-->

                    <!--                <v-layout align-center row  v-if="warranty === 2">-->
                    <!--                    <v-flex offset-md4 row>-->
                    <!--                        <v-flex md6>-->
                    <!--                            <v-datetime-picker label="Chọn ngày bắt đầu" v-model="fromDateVal" :min="fromDateVal" :max="toDateVal" > </v-datetime-picker>-->
                    <!--                        </v-flex>-->
                    <!--                        <v-flex md6>-->
                    <!--                            <v-datetime-picker label="Chọn ngày kết thúc" v-model="toDateVal" :min="fromDateVal" :max="toDateVal"> </v-datetime-picker>-->
                    <!--                        </v-flex>-->
                    <!--                    </v-flex>-->
                    <!--                </v-layout>-->
                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Tốc độ buff:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-radio-group v-model="filterbuffSpeed" row>
                                <v-radio label="Nhanh (vèo cái lên luôn)" :input-value="filterbuffSpeed===0" ></v-radio>
                                <v-radio label="Từ từ (Chậm mà chắc)" :input-value="filterbuffSpeed===1"></v-radio>
                            </v-radio-group>
                        </v-flex>
                    </v-layout>
                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Lọc nâng cao:</label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <v-switch
                                    v-model="filter"
                                    :label="`ON`"
                            ></v-switch>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex v-if="filter" offset-md4>
                            <v-row class="ml-1">
                                <span> Hệ thống sẽ </span>
                                <span class="text-color ml-1">thu phí thêm 40% </span>
                                <span class="ml-1"> cho </span>
                                <span class="text-color ml-1"> 1 lựa chọn nâng cao</span>
                            </v-row>
                            <v-row class="ml-1">
                                <v-flex md12>
                                    <v-card >
                                        <v-container>
                                            <v-layout align-center>
                                                <v-flex md12 row >
                                                    <v-flex md3 align-self-center pl-2 class="text-color">
                                                        Giới tính:
                                                    </v-flex>
                                                    <v-flex md9 class="text-color">
                                                        <v-radio-group v-model="filterSex" row>
                                                            <v-radio label="Tất cả" :input-value="filterSex===0" ></v-radio>
                                                            <v-radio label="Nam" :input-value="filterSex===1"></v-radio>
                                                            <v-radio label="Nữ" :input-value="filterSex===2"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex md12 row class="text-color">
                                                    <v-flex md3 align-self-center>
                                                        Độ tuổi:
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <v-select
                                                                solo
                                                                :items="limitAgesFrom"
                                                                v-model="limitAgeFrom"
                                                                item-text="name"
                                                                item-value="value"
                                                                class="float-left"
                                                        ></v-select>
                                                    </v-flex>
                                                    <v-flex md3 align-self-center text-center>
                                                        Đến
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <v-select
                                                                solo
                                                                :items="limitAgesTo"
                                                                v-model="limitAgeTo"
                                                                item-text="name"
                                                                item-value="value"
                                                                class=""
                                                        ></v-select>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>

                                            <!-- <v-layout>
                                                <v-flex md12 row class="text-color">
                                                    <v-flex md3 align-self-center>
                                                        Số bạn bè:
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <v-select
                                                                solo
                                                                :items="limitFriendsFrom"
                                                                v-model="limitFriendFrom"
                                                                item-text="name"
                                                                item-value="value"
                                                                class="float-left"
                                                        ></v-select>
                                                    </v-flex>
                                                    <v-flex md3 align-self-center text-center>
                                                        Đến
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <v-select
                                                                solo
                                                                :items="limitFriendsTo"
                                                                v-model="limitFriendTo"
                                                                item-text="name"
                                                                item-value="value"
                                                                class=""
                                                        ></v-select>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout> -->
                                        </v-container>
                                    </v-card>
                                </v-flex>
                            </v-row>

                        </v-flex>
                    </v-layout>
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Chế độ bảo hành: </label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <v-select
                                    solo
                                    :items="guarantees"
                                    v-model="guarantee"
                                    item-text="name"
                                    item-value="value"
                                    @change="initDefault"
                            >
                                <option value="">Có</option>
                            </v-select>
                        </v-flex>

                        <v-layout align-center row>
                            <v-flex offset-md4>
                                <div class="v-sheet theme--light explain">
                                    <span>Quy định về chế độ bảo hành:</span><br>
                                    <span class="red_text">Thời gian bảo hành là 7 ngày tính từ ngày tạo buff!</span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-layout>

                    <v-layout align-center row class="pa-0" v-if="typeSeeding !== SEEDING.COMMENT">
                        <v-flex md4>
                            <label class="text-color">Số lượng cần tăng:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="amount"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span>{{ noteAmount1 }}</span><br>
                                <span class="red_text">{{ noteAmount2 }}</span>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Giá tiền mỗi tương tác:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="price"
                                    type="number"
                                    :min="priceMin"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span class="red_text">{{ notePrice }}</span>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Ghi chú:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-textarea
                                    solo
                                    v-model="notes"
                                    placeholder="Nhập nội dung ghi chú về tiến trình của bạn"
                                    height="100px"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>

                </v-form>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-card :color="COLOR.CLICK_MENU_COLOR" height="100px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Bạn sẽ buff {{totalAmount}}  với giá <strong class="green--text">{{price | currency_init}}</strong> Coin/Follow
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text" @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>

                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex md2 text_notes>
                <Attention />
            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                    indeterminate
                    color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
    import Attention from "~/components/Attention";
    import { COLOR, SEEDING, defaultFbPost } from "~/config/constant";
    import { validURLFb} from "../../common/helper.string";
    import moment from 'moment';
    import Swal from 'sweetalert2';
    import {FB_POST_GET_LIST_REACTION, FB_POST_GET_LIST_SEEDING, FB_FOLLOW_SAVE_PROCESS, FB_JOB_CALCULATE, FB_GET_PROFILE_ID_BUFF} from "~/store/actions.type";
    import $ from 'jquery';

    export default {
        name: "FbFanPageCreateProcess",
        components: {
            Attention
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                COLOR: COLOR,
                SEEDING: SEEDING,

              guarantees: ['Bảo hành (Bảo hành nếu tụt quá 10%)', 'Không bảo hành (Bảo hành nếu tụt quá 70%)'],
              guarantee: 'Không bảo hành (Bảo hành nếu tụt quá 70%)',

                // Link hoac ID ca nhan
                linkOrId: "",
                linkOrIdClone: "",

                // Cac loai seeding
                listSeedingApi: [],
                typeSeeding: 5,
                typeSeedings : [],

                // Chon cam xuc
                //cxImg: 2,
                listReaction: [],


                // Che do bao hang
                warranty: 1,
                warranties : [
                    {
                        name: "Không bảo hành (Bảo hành nếu tụt quá 70%)",
                        value: 1
                    },
                    {
                        name: "Bảo hành (Bảo hành nếu tụt quá 10%)",
                        value: 2
                    }
                ],
                fromDateVal: '',
                toDateVal: '',


                // Loc nang cao
                filter: false,
                filterSex: 0,
                filterbuffSpeed: 1,
                limitAgeFrom: '',
                limitAgesFrom: ['NONE'].concat(this.setArray(13,65, 1)),
                limitAgeTo: '',
                limitAgesTo: [],

                limitFriendFrom: '',
                limitFriendsFrom: ['NONE'].concat(this.setArray(100,5000, 100)),
                limitFriendTo: '',
                limitFriendsTo: [],

                // So luong can tang
                amount: defaultFbPost.LIKE.amount,
                noteAmount1: 'Mẹo nhỏ: Hệ thống ưu tiên chạy các job giá cao trước nên nếu bạn cần gấp bạn có thể set giá job của mình cao hơn 1 vài đồng để chạy nhanh nhất có thể nhé.',
                noteAmount2: 'Lưu ý: Nên buff dư thêm 30 - 50% trên tổng số lượng để tránh tụt.',

                // Gia tien
                price: 0,
                priceMin: 0,
                notePrice: "Giá thấp nhất: 120 coin",

                // Noi dung can comment
                noteComment1: "Nghiêm cấm bình luận những nội có cử chỉ, lời nói thô bạo, khiêu khích, trêu ghẹo, xúc phạm nhân phẩm, danh dự của Cá nhân hoặc Tổ chức.",
                noteComment2: "Nếu cố tình buff bạn sẽ bị trừ hết tiền và band khỏi hệ thống vĩnh viễn, và phải chịu hoàn toàn trách nhiệm trước pháp luật.",


                // Ghi chu
                notes: "",

                // Tong so coin
                totalCoin: '',
                totalAmount: '',

                // Rules

                videoId: '',
                videoStatus: true,
            }
        },

        created() {
            this.customDataFromApi();
        },

        watch: {
            linkOrId(){
                this.linkOrIdClone = this.linkOrId;
                if (validURLFb(this.linkOrId, 'facebook')) {
                    this.getPostId();
                }
            },
            priceMin() {
                this.notePrice = "Giá thấp nhất: "+ this.priceMin +" coin";
            },
            filter() {
                this.calculate();
            },
            filterSex() {
                this.calculate();
            },
            limitAgeFrom(){
                this.limitAgesTo = this.setArray(this.limitAgeFrom, 65, 1);
                this.calculate();
            },
            limitAgeTo(){
                this.calculate();
            },
            limitFriendFrom(){
                this.limitFriendsTo = this.setArray(this.limitFriendFrom, 5000, 100);
                this.calculate();
            },
            limitFriendTo(){
                this.calculate();
            },

            amount() {
                this.updateTotal();
                this.calculate();
            },
            price() {
                this.updateTotal();
                this.calculate();
            }
        },
        mounted() {
            if ($('.menu-fb-buff').parent().attr('aria-expanded') == "false") {
                $('.menu-fb-buff').click();
            }
        },
        methods: {
            async getPostId() {
                let data  =  await this.$store.dispatch(FB_GET_PROFILE_ID_BUFF, {facebook_link: this.linkOrId});
                if (data) {
                    this.linkOrId = data +'';
                }

            },
            async customDataFromApi() {
                this.listSeedingApi =  await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);
                this.listReaction = await this.$store.dispatch(FB_POST_GET_LIST_REACTION);

                // Set seeding
                for(let i=0; i< this.listSeedingApi.length; i++) {
                    if ( this.listSeedingApi[i].type === 'facebook-sub') {
                        this.typeSeedings.push({name:  this.listSeedingApi[i].title, value:  this.listSeedingApi[i].id });

                        if (this.listSeedingApi[i].video) {
                            let videoId = this.youtube_parser(this.listSeedingApi[i].video);
                            if (videoId) {
                                this.videoId = videoId;
                            }
                        }
                    }
                }
                this.initDefault();
            },

            initDefault() {
                // seeding
                switch(this.typeSeeding) {
                    case SEEDING.FOLLOW:
                        this.totalAmount = this.amount  + " Follow" ;
                        this.price = this.price ? this.price : this.listSeedingApi[this.typeSeeding - 1].fix_coin;
                        this.priceMin = this.priceMin ? this.priceMin : this.listSeedingApi[this.typeSeeding - 1].fix_coin;
                        break;
                }

                this.calculate();
                // warranty
                this.fromDateVal = moment().format('YYYY-MM-DD HH:mm');
                this.toDateVal = moment().add(7,'days').format('YYYY-MM-DD HH:mm');

            },

            updateTotal() {
                switch(this.typeSeeding) {
                    case SEEDING.FOLLOW:
                        this.totalAmount = this.amount  + " Follow" ;
                        break;
                }
            },
            setArray (min,max,step){
                let array = [],
                    j = 0;
                for(let i = min; i <= max; i=i+step){
                    array[j] = i;
                    j++;
                }
                return array;
            },
            validateForm() {
                let valid = true;
                // link or ID
                if (this.linkOrId.trim() === '') {
                    return {check: false, message: "Vui lòng nhập link FB cá nhân"};
                }

                if (!validURLFb(this.linkOrIdClone,'facebook')) {
                    return {check: false, message: "Link Fanpage không hợp lệ"};
                }
                return {check: valid, message: ""};
            },
          validatePrice() {
            let valid = true;
            if (this.price < this.priceMin) {
              return {checkValidatePrice: false, message: 'Giá mỗi seeding không được thấp hơn giá đề xuất'}
            }
            return {checkValidatePrice: valid, message: ''}
          },
                getParams() {
                let params = {
                    post_link: this.linkOrIdClone,
                    seeding_type_id: this.typeSeeding,
                    number_seeding: this.amount,
                    total_coin: this.totalCoin,
                    note: this.notes,
                    customer_fix_coin: this.price,
                    guarantee: this.guarantee === 'Bảo hành (Bảo hành nếu tụt quá 10%)' ? true : null,
                    buff_speed: this.filterbuffSpeed
                };
                if (this.filter === true) {
                    if (this.filterSex !== 0) {
                        params.gender = this.filterSex;
                    }
                    if (this.limitAgeFrom !== 'NONE' && this.limitAgeFrom !== '') {
                        params.age_min = this.limitAgeFrom;
                        params.age_max = this.limitAgeTo;
                    }
                    if (this.limitFriendFrom !== 'NONE' && this.limitFriendFrom !== '') {
                        params.friend_min = this.limitFriendFrom;
                        params.friend_max = this.limitFriendTo;
                    }
                }
                return params;
            },
            async saveProcessBk() {
                Swal.fire('Chức năng này đang bảo trì, nếu bạn muốn tạo job này ngay bây giờ, hãy liên hệ admin qua mục chat facebook');
                return;
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
              let validatePrice = this.validatePrice();
              if (validateForm.check) {
                if (!validatePrice.checkValidatePrice) {
                  Swal.fire(
                    validatePrice.message,
                    '...',
                    'error'
                  )
                } else {
                  try {
                    Swal.fire({
                      title: 'Xác nhận',
                      text: "Bạn có chắc chắn muốn tạo tiến trình ",
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'Đồng ý!',
                      cancelButtonText: 'Không'
                    }).then((result) => {
                      if (result.value) {
                        this.overlay = true;
                        this.saveProcessApi();
                      }
                    })
                  } catch (error) {
                    console.log(error);
                  }
                }
              } else {
                Swal.fire(
                  validateForm.message,
                  '...',
                  'error'
                )
              }
            },
            async saveProcessApi() {
                let check = await this.$store.dispatch(FB_FOLLOW_SAVE_PROCESS, this.getParams());
                if(check) {
                    this.overlay = false;
                    this.$router.go();
                } else {
                    this.overlay = false;
                }


            },
            async calculate() {
                let check = await this.$store.dispatch(FB_JOB_CALCULATE, this.getParams());
                if(check) {
                    this.totalCoin = check.total_coin;
                }

            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .fb-post-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details{
            display: none;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }
        .div-cx {
            height: 60px;
            .cx-img {
                cursor: pointer;
                &hover {
                    opacity: 0.8;
                }
            }
            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }
    }
</style>
